export default __webpack_public_path__ + "static/media/vscode.d36646a7.svg";